import { Injectable } from '@angular/core';
import {map} from 'rxjs/operators';
import {HomologacionEstado} from '../_models/homologacion-estado';
import { HttpClient } from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {AppSettings} from '../../proyect.conf';
import {HomologacionPlanCargo} from '../_models/homologacion-plan-cargo';

@Injectable({
  providedIn: 'root'
})
export class HomologacionPlanCargoService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/homologacionesPlanesCargos';

  constructor(  private httClient: HttpClient, private autServicio: AutenticacionService  ) { }


  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as HomologacionPlanCargo[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as HomologacionPlanCargo[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as HomologacionPlanCargo ) );
  }

  crear( regCrear: HomologacionPlanCargo ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as HomologacionPlanCargo ) );
  }

  actualizar( regActualizar: HomologacionPlanCargo ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as HomologacionPlanCargo ) );
  }

  validarDobleRegistroAlmacenado(idPlanCargoProducto: string, idComodinPlanCargo: string) {
    return this.httClient.get( this.rutServicio + '/validarDobleRegistro/idPlanCargoProducto/' + idPlanCargoProducto + '/idComodinPlanCargo/' + idComodinPlanCargo).pipe( map( res => res as any ) );
  }
}

